import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import loadable, { LoadableLibrary } from '@loadable/component';

import { Container } from '../../../../../symphony';

import { ActionType, RequestType } from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ErrorCodes } from '../../../../../api/private/global.interface';
import { IMaterialStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

const TIY: LoadableLibrary<unknown> = loadable.lib(
	() => import(/* webpackPrefetch: true */ '../../../../../lePlayground/public/SlPlaygroundTIY/SlPlaygroundTIY'),
);

export function TIYMaterial(): JSX.Element {
	const { materialId, courseAlias } = useParams();
	const { actions$ } = Container.take(SlLEContext, SlActions);

	useEffect(() => {
		actions$.next({
			type: ActionType.OnTIYMaterialMount,
			requestType: RequestType.Parallel,
			data: {
				alias: courseAlias,
				materialId: +materialId,
			},
		});
	}, []);

	const solveMaterialCallback = (statusChanges: IMaterialStatus[]): void => {
		actions$.next({
			type: ActionType.UpdateStatuses,
			requestType: RequestType.Parallel,
			data: {
				statusChanges,
			},
		});
	};

	const onSessionError = () => {
		actions$.next({
			type: ActionType.ExpiredSessionIdError,
			requestType: RequestType.Parallel,
		});
	};

	/* TODO: understand 403 case handling */
	return (
		<TIY>
			{({ SlPlaygroundTIY }) => (
				<SlPlaygroundTIY
					configs={{
						materialId,
						soloLearnUrl: Container.take(
							SlLEContext,
							'soloLearnUrl',
						),
						courseAlias,
					}}
					solveMaterialCallback={solveMaterialCallback}
					errorHandler={{
						[ErrorCodes.ExpiredSession]: onSessionError,
					}}
				/>
			)}
		</TIY>
	);
}
